<template>
  <div class="pay-pc" >
    <div class="step2">
      <div class="titel">
        “乐游人生”境内旅行救援保险
      </div>
      <div class="data-list">
        <van-collapse v-model="activeNames">
          <van-collapse-item name="1" class="collapse-item">
            <template #title>
              <div class="item-name" style="display:flex"> <div class="px1bar"></div> 保险明细</div>
            </template>
            <div class="item-content">
              <div class="item">
                <div class="label">保险计划：</div>
                <div class="text">{{planName}}</div>
              </div>
              <div class="item">
                <div class="label">保障周期：</div>
                <div class="text">
                  {{moment(startTime).format('YYYY-MM-DD')}} 至 {{moment(endTime).format('YYYY-MM-DD')}}
                  
                </div>
              </div>
              <div class="item">
                <div class="label">保障内容：</div>
                <div class="text">
                  <ul class="summary-info" v-if="detail.plans">
                    <li v-for="(item,index) in this.detail.plans[planIndex].summarys" :key="index"> 
                      <div class="name">{{item.name}}</div>
                      <div class="price">{{item.price | countFilter}}元</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </van-collapse-item>
          <div class="bar10px"></div>
          <van-collapse-item name="2" class="collapse-item">
            <template #title>
              <div class="item-name" style="display:flex"> <div class="px1bar"></div> 投保人信息</div>
            </template>
            <div class="item-content">
              <div class="item">
                <div class="label">投保人姓名：</div>
                <div class="text">{{policyHolder.name}}</div>
              </div>
              <div class="item">
                <div class="label">证件类型：</div>
                <div class="text">{{policyHolder.idType}}</div>
              </div>
              <div class="item">
                <div class="label">证件号：</div>
                <div class="text">{{policyHolder.idCode}}</div>
              </div>
              <div class="item">
                <div class="label">性别：</div>
                <div class="text">{{policyHolder.sex==1?'男':'女'}}</div>
              </div>
              <div class="item">
                <div class="label">出生日期：</div>
                <div class="text">{{moment(policyHolder.birthday).format('YYYY-MM-DD')}}</div>
              </div>
              <div class="item">
                <div class="label">手机号：</div>
                <div class="text">{{policyHolder.phone}}</div>
              </div>
              <div class="item">
                <div class="label">邮箱：</div>
                <div class="text">{{policyHolder.mailbox}}</div>
              </div>
            </div>
          </van-collapse-item>
          <div class="bar10px"></div>
          <van-collapse-item name="3" class="collapse-item">
            <template #title>
              <div class="item-name" style="display:flex"> <div class="px1bar"></div>被保人信息</div>
            </template>
            <div class="item-content">
              <div class="limargin" v-for="(item,index) in InsuredList" :key="index">
                <div class="item">
                  <div class="label">被保人姓名：</div>
                  <div class="text">{{item.name}}</div>
                </div>
                <div class="item">
                  <div class="label">证件类型：</div>
                  <div class="text">{{item.idType}}</div>
                </div>
                <div class="item">
                  <div class="label">证件号：</div>
                  <div class="text">{{item.idCode}}</div>
                </div>
                <div class="item">
                  <div class="label">性别：</div>
                  <div class="text">{{item.sex == 1?'男':'女'}}</div>
                </div>
                <div class="item">
                  <div class="label">出生日期：</div>
                  <div class="text">{{moment(item.birthday).format('YYYY-MM-DD')}}</div>
                </div>
                <div class="item">
                  <div class="label">手机号：</div>
                  <div class="text">{{policyHolder.phone}}</div>
                </div>
                <div class="item">
                  <div class="label">邮箱：</div>
                  <div class="text">{{policyHolder.mailbox}}</div>
                </div>
              </div>
              
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
    <div class="sub">
      <div class="left">
        <span class="label" style="margin-right:4px">总价</span>
        <span class="value">
          <span class="fu">¥</span> {{payPrice}}
        </span>
      </div>
      <div class="btn" @click="payOrder()">确认支付</div>
    </div>
  </div>
</template>

<script>
import storejs from "store";
import moment from 'moment';
import { Collapse, CollapseItem,Icon  } from 'vant';
import wechatService from '@/services/request/wechatService.js'
import $ from "jquery";

export default {
  name: 'payPc',
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]:CollapseItem,
    [Icon.name]:Icon
  },
  data(){
    return{
      moment:moment,
      publicData: storejs.get("publicData"),
      activeNames:[1],
      id:'',
      detail:{},
      planIndex:0,
      planName:'',
      dateIndex:0,
      startTime:'',
      endTime:'',
      days:0,
      step1Data:{
        name:'',
        planName:'',
        planIndex:0,
        planAge:'',
        planAddr:'',
        startTime:'',
        endTime:''
      },
      policyHolder:{//投保人信息
        name:'',
        idType:'身份证',
        idCode:'',
        sex:'男',
        birthDay:'',
        birthDayTime:moment(1594137600000).format('YYYY-MM-DD'),
        phone:'',
        email:'',
        currentDate:''
      },
      InsuredList:[],
      activeNames: ['1','2','3'],
      payPrice:0,
      openId:'',
      unionId:'',
      accountBillIds:[]
    }
  },
  watch: {
  },
  mounted() {
    this.initStyle()
    // wechatService.auth(0, ({
    // openid, unionid
    // }) => {
    //   if(!!openid && !!unionid) {
    //     this.unionId = unionid
    //     this.openId = openid
               
    //   }
    // }, true)
    this.init()
    
  },
  beforeDestroy: function() {
    
  },
  methods: {
    initStyle(){
      // let el = document.getElementById('bg')
      let height = window.innerHeight
      $('#order-detail').css({'min-height':height + 'px'})
    },
    async init(){
      await this.getOrderDetail()
      await this.getDetail()
    },
    async payOrder(){
      var self = this
      let wechatParams={
        accountBillId:  this.accountBillIds[0],
        paytype:'W01',
        acct:this.openId?this.openId:this.$route.query.accountId
      }
      let wechatRes = await this.$http.post("/api/order.union.create", wechatParams);
      console.log('wechatRes',wechatRes)
      if(wechatRes.code == 0){//成功
        // let data =  JSON.parse(wechatRes.t.payinfo)
        // console.log('payInfo',data)
        window.open(wechatRes.t.payinfo)
        // wechatService.pay({
        //   data,
        //   cb: self.wxPayCallback
        // });
      }
          
    },
    wxPayCallback(retStr) {
      console.log('retStr',retStr)
      let self = this;
      if (retStr == "success") {
        if(this.erweimaImg){
          this.erweimaFlag = true
        }else{
          // weui.alert("支付成功", { isAndroid: false }, () => {
          //   self.$router.push({
          //       path: "/app/pay/order",
          //       query: {
          //         iid: self.cid || self.iid
          //       }
          //     });
          // });
        }
        
      } else if (retStr == "cancel") {
        this.$toast.fail("支付失败：用户取消支付");
      } else if (retStr == "error") {
        this.$toast.fail("支付失败：未知错误");
      } else {
        this.$toast.fail(`支付失败：${retStr}`);
      }
    },
    async getOrderDetail(){
      let res = await this.$http.post("api/bill/batchGet", {billIds:this.$route.query.id});
      if(res.code == 0){
        this.id = res.t[0].productId
        this.planName = res.t[0].plan
        this.days = (res.t[0].endDate - res.t[0].startDate)/86400000
        this.startTime = res.t[0].startDate
        this.endTime = res.t[0].endDate
        console.log(this.days)
        let insurePeople = JSON.parse(res.t[0].insurePeople)
        this.policyHolder=insurePeople
        this.InsuredList = res.t
        this.payPrice = 0
        let ids = []
        res.t.forEach((item)=>{
          this.payPrice = this.payPrice + item.payPrice
          ids.push(item.accountBillId)
        })
        this.accountBillIds = ids
      }
      console.log(res)
    },
    async getDetail() {
      //获取产品信息
      let res = await this.$http.post("api/insuranceProduction/get", { id: this.id });
      if (res.code == 0) {
        let detail = res.t;
        detail.plans = JSON.parse(detail.plans);
        detail.files = JSON.parse(detail.files);
        try {
          detail.summarys = JSON.parse(detail.summarys);
        } catch (error) {}

        this.detail = detail;

        let ageArr = []
        detail.plans[0].cycle.forEach(el => {
          ageArr.push({
            start:el.startAge,
            end:el.endAge
          })
        });

        for(let i = ageArr.length; i > 0; i--) {
          for(let j = i - 1; j > -1 ; j--) {
              if( JSON.stringify(ageArr[i]) === JSON.stringify(ageArr[j])) {
                  ageArr.splice(j, 1)
              }
          }
        }
        this.setAges = ageArr
        console.log('detail',this.detail)
        //
        this.step1Data.name = this.detail.title
        // this.step1Data.planName = this.detail.plans[this.$route.query.plan].name
        // this.step1Data.startTime = this.$route.query.startTime
        // let endDays = this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].end
        // this.oneprice = this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].price
        // console.log('endDays',endDays)
        // this.step1Data.endTime =  moment(moment(this.step1Data.startTime).valueOf() + 86400000*endDays).format("YYYY-MM-DD")  
        // console.log(moment(this.step1Data.startTime).valueOf() + 86400000*endDays)
        this.detail.plans.forEach((item,index)=>{
          if(item.name == this.planName){
            this.planIndex = index
          }
          // this.plans.push(item.name)
        })

        this.step1Data.planAge = this.detail.fromAge + '周岁' +  '-' +  detail.endAge + '周岁'

        document.title = this.detail.title + '报名'
        

      } else {
        this.$toast.fail(res.msg);
      }

      console.log(res);
    },
  },
}
</script>

<style lang="scss" scoped>
  .pay-pc{
    padding: 15px;
    box-sizing: border-box;
    padding-bottom: 80px;
    box-sizing: border-box;

    .px1bar{
      width: 2px;
      height:12px;
      background:#00D385;
      
    }
    .bar10px{
      height:4px;
      background:rgba(244,244,244,1);
      width: 100%;

    }
    .step2{
      .titel{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,211,133,1);
        height: 40px;
        line-height: 40px;
      }
      .collapse-item{
        .item-content{
          padding-bottom: 6px;
          .limargin{
            margin-bottom: 15px;
          }
          .item{
            display: flex;
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(102,102,102,1);
            .label{
              width: .8rem;
              flex-shrink: 0;

            }
            .text{
              flex: 1;
              color: #333333;
              line-height: 20px;
              .summary-info{
                width: 100%;
                padding-top: 5px;
                box-sizing: border-box;
                // ul{
                  li{
                    display: flex;
                    .price{
                      width: 80px;
                      flex-shrink: 0;

                    }
                    .name{
                      flex: 1;
                    }
                  }
                // }
              }
                  
            }
          }
        }
      }
    }
    .sub {
    margin-top: 6px;
    width: 100%;
    padding: 15px;
    // background: #fff;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    padding-bottom: 6px;
    padding-top: 6px;
    background: #fff;
    display: flex;
    box-shadow: 0px 0 10px rgba(0, 0, 0, 0.04);
    .left {
      width: 60%;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-left: 20px;
      box-sizing: border-box;
      .value {
        color: #ff1414;
        .fu {
          font-size: 12px;
        }
      }
    }
    .btn {
      // width: 100%;
      flex: 1;
      height: 40px;
      background: #02bad3;
      text-align: center;
      color: #fff;
      line-height: 40px;
      border-radius: 40px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
  }
</style>

<style lang="scss">
  .pay-pc{
    .step2{
      .data-list{
        .van-cell{
          padding: 0;
        }
        .van-hairline--top-bottom::after{
          border-width: 0;
        }
        .van-collapse-item__title--expanded::after{
          display: none;
        }
        .van-cell__title{
          height: 35px;
          line-height: 35px;
        }
        .van-collapse-item__content{
          padding:0
        }
        .item-name{
          align-items: center;
          font-size:16px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(51,51,51,1);
          .px1bar{
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>